import { Box } from "@mui/material";
import PortfolioHeaderActions from "./PortfolioHeaderActions";

import PortfolioFooterSummary from "./PortfolioFooterSummary";
import PortfolioGrid from "./PortfolioGrid";

import { useOktaAuth } from "@okta/okta-react";
import { useEffect, useRef, useState } from "react";
import { useAuth, ROLES } from "../../components/auth/AuthProvider";

export default function Portfolio() {
    const { role } = useAuth();
    const [searchText, setSearchText] = useState("");
    // Initialize myPortfolioOnly based on user role
    const [myPortfolioOnly, setMyPortfolioOnly] = useState(() => {
        // If user is a partner, default to ON (true)
        // Otherwise, default to OFF (false)
        return role === ROLES.PARTNER;
    });
    const { authState, oktaAuth } = useOktaAuth();
    const tableRef = useRef(null);
    const [footerSummary, setFooterSummary] = useState({
        rowCount: 0,
        amountInvested: 0,
    });

    const handleExport = () => {
        tableRef.current.exportToExcel();
    };

    const handleOpenColumns = () => {
        tableRef.current?.openColumnsPanel();
    };

    const handleOpenFilters = () => {
        tableRef.current?.openFiltersPanel();
    };

    const [user, setUser] = useState(null);

    useEffect(() => {
        console.log('Auth state changed:');
        if (authState?.isAuthenticated) {
            let a = authState.idToken?.claims
            console.log('User info:', a);
        }
    }, [authState, oktaAuth]);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                gap: 2,
            }}
        >
            <PortfolioHeaderActions
                searchText={searchText}
                onSearchChange={setSearchText}
                onExport={handleExport}
                onOpenColumns={handleOpenColumns}
                onOpenFilters={handleOpenFilters}
                myPortfolioOnly={myPortfolioOnly}
                onMyPortfolioToggle={setMyPortfolioOnly}
            />
            <PortfolioGrid
                searchText={searchText}
                tableRef={tableRef}
                onSummaryChange={setFooterSummary}
                myPortfolioOnly={myPortfolioOnly}
            />
            <PortfolioFooterSummary
                rowCount={footerSummary.rowCount}
                amountInvested={footerSummary.amountInvested}
            />
        </Box>
    );
};
